export function formatRunStartedAt(startedAt: string): string {
  const parsed = new Date(startedAt);
  if (Number.isNaN(parsed.getTime())) {
    return 'Unknown';
  }

  const iso = parsed.toISOString();
  return `${iso.slice(0, 10)} ${iso.slice(11, 16)} UTC`;
}

export function buildRunDisplayTitle(run: {
  displayTitle?: string;
  workflowType?: string;
  metadata?: Record<string, any>;
}): string {
  if (run.displayTitle) return run.displayTitle;

  const progressTitle = run.metadata?.pipelineProgress?.title;
  if (typeof progressTitle === 'string' && progressTitle.trim()) {
    return progressTitle;
  }

  const wfType = (run.workflowType || 'workflow').replace(/_/g, ' ');
  return `${wfType.charAt(0).toUpperCase()}${wfType.slice(1)}`;
}
